import dataUtil from '@/util/DataUtil'
import StorageService from '@/services/StorageService'
export default {
  namespaced: true,
  state: {
    groups: [
      {
        name: 'Site',
        items: [
          {
            name: 'Room and hall fees',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Site staff',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Equipment',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Tables and chairs',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'Refreshments',
        items: [
          {
            name: 'Food',
            estimatedAmount: 2000,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Drinks',
            estimatedAmount: 800,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Tissues & others',
            estimatedAmount: 200,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'Decorations',
        items: [
          {
            name: 'Flowers',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Paper supplies',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Background',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'Program',
        items: [
          {
            name: 'Goodie Bags',
            estimatedAmount: 3200,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Token of Appreciation',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'Publicity',
        items: [
          {
            name: 'Graphics work',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Photocopying/Printing',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Cameraman',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'Miscellaneous',
        items: []
      },
      {
        name: 'NUS',
        items: [
          {
            name: 'Flights',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Accommodation',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Per-diem',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'NTU',
        items: [
          {
            name: 'Flights',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Accommodation',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Per-diem',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'SMU',
        items: [
          {
            name: 'Flights',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Accommodation',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Per-diem',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'SUTD',
        items: [
          {
            name: 'Flights',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Accommodation',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Per-diem',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'I2R',
        items: [
          {
            name: 'Flights',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Accommodation',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          },
          {
            name: 'Per-diem',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      },
      {
        name: 'Others',
        items: [
          {
            name: 'Pre-event Dinner',
            estimatedAmount: 0,
            actualAmount: 0,
            description: ''
          }
        ]
      }
    ]
  },
  getters: {
    getGroups (state) {
      return state.groups
    },
    getTotal (state) {
      return dataUtil.getTotal(state.groups)
    }
  },
  mutations: {
    getGroups (state) {
      state.groups = []
    },
    addGroup (state, payload) {
      dataUtil.addGroup(state.groups, payload.itemName)
    },
    saveData (state) {
      StorageService.saveExpense(state.groups)
    },
    loadData (state) {
      let groups = StorageService.loadExpense()
      if (groups && groups.length > 0) {
        state.groups = groups
      }
    }
  },
  actions: {
    getGroups (context) {
      context.commit('getGroups')
    },
    addGroup (context, payload) {
      context.commit('addGroup', payload)
    },
    saveData (context) {
      context.commit('saveData')
    },
    loadData (context) {
      context.commit('loadData')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ExpenseModule.js